import { Navigate, type RouteObject } from 'react-router-dom'

import { LoginPage } from '@/app/auth/LoginPage'
import { FeatureFlagsPage } from '@/app/featureFlags/FeatureFlagsPage'
import { OrgDetailPage } from '@/app/organizations/OrgDetailPage'
import { FeatureFlagsTab } from '@/app/organizations/OrgDetailPage/components/FeatureFlagsTab'
import { IntakeFormsTab } from '@/app/organizations/OrgDetailPage/components/IntakeFormsTab'
import { LocationsTab } from '@/app/organizations/OrgDetailPage/components/LocationsTab'
import { OverviewTab } from '@/app/organizations/OrgDetailPage/components/OverviewTab'
import { ProductFlagsTab } from '@/app/organizations/OrgDetailPage/components/ProductFlagsTab'
import { StaffTab } from '@/app/organizations/OrgDetailPage/components/StaffTab'
import { OrgDirectoryPage } from '@/app/organizations/OrgDirectoryPage'
import { ProtectedRoute } from '@/routes/ProtectedRoute'

export const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/orgs',
    element: (
      <ProtectedRoute>
        <OrgDirectoryPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/feature-flags',
    element: (
      <ProtectedRoute>
        <FeatureFlagsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/orgs/:orgId',
    element: (
      <ProtectedRoute>
        <OrgDetailPage />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to='overview' replace /> },
      { path: 'overview', element: <OverviewTab /> },
      { path: 'locations', element: <LocationsTab /> },
      { path: 'staff', element: <StaffTab /> },
      { path: 'product-flags', element: <ProductFlagsTab /> },
      { path: 'feature-flags', element: <FeatureFlagsTab /> },
      { path: 'intake-forms', element: <IntakeFormsTab /> },
    ],
  },
  {
    path: '/',
    element: <Navigate to='/orgs' replace />,
  },
  {
    path: '*',
    element: <Navigate to='/orgs' replace />,
  },
]
